import { NavMode } from "../../../../api/robocore/dex_interfaces";
import { SynthMap } from "../../../../api/robocore/SynthMapChannel";
import { angleFromTo } from "../../../../visuals/visual-utils";
import { AgentEvents } from "../../agents/BaseAgent";
import { RobotAgent } from "../RobotAgent";
import { RTVisualizer } from "./RTVisualizer";
import * as THREE from 'three';

export class SynthMapVisualizer extends RTVisualizer {
  private base = new THREE.Group();
  constructor(agent: RobotAgent) {
    super(agent);
    agent.on(AgentEvents.StateChange, (dgram: Partial<RobotAgent>) => {
      if (dgram.navMode) {
        if (dgram.navMode === NavMode.SLAM || dgram.navMode === NavMode.Auto) {
          this.base.visible = true;
        } else {
          this.base.visible = false;
        }
      }
    });
    agent.synthMapChannel.on('map', (map: SynthMap) => {
      if (!this.active) {
        return;
      }
      this.base.clear();
      if (!this.base.parent) {
        this.agent.visual.obj.parent?.add(this.base);
      }
      buildSynthWalls(this.base, map.lines, map.heights, 0.5);
    });
  }
}

export function buildSynthWalls(
  parent: THREE.Object3D,
  points: THREE.Vector3[],
  heights: number[],
  thickness = 0.2,
): void {

  const material = new THREE.MeshBasicMaterial({
    color: 0x00ff00,
    transparent: true, 
    opacity: 0.5
  });
  for (let i = 0; i < points.length - 1; i += 2) {
    const nextIndex = (i + 1) % points.length;
    const wallGeometry = new THREE.BoxGeometry(
      points[i].distanceTo(points[nextIndex]),
      thickness,
      heights[i]
    );
    const wall = new THREE.Mesh(wallGeometry, material);
    wall.name = `wall_${i}`;
    wall.position.copy(points[i].clone().lerp(points[nextIndex], 0.5));
    const angleBetween = angleFromTo(points[i], points[nextIndex]);
    // console.log(`Building  wall from ${points[i].toArray()} to ${points[nextIndex].toArray()} at angle ${angleBetween}`);
    wall.rotation.z = angleBetween;
    wall.position.z = heights[i] * 0.5;
    parent.add(wall);
  }
}

